/** Crafting recipes — pure data. Crafted at the workbench inside the house. */
export interface Recipe {
  id: string;
  /** Item id produced. */
  output: string;
  outputQty: number;
  inputs: { itemId: string; qty: number }[];
}

export const RECIPES: Recipe[] = [
  { id: 'craft_fence', output: 'fence', outputQty: 3, inputs: [{ itemId: 'wood', qty: 1 }] },
  { id: 'craft_path', output: 'path', outputQty: 5, inputs: [{ itemId: 'wood', qty: 1 }] },
  { id: 'craft_lantern', output: 'lantern', outputQty: 1, inputs: [{ itemId: 'wood', qty: 2 }] },
  { id: 'craft_scarecrow', output: 'scarecrow', outputQty: 1, inputs: [{ itemId: 'wood', qty: 3 }] },
  { id: 'craft_bench', output: 'bench', outputQty: 1, inputs: [{ itemId: 'wood', qty: 4 }] },
  { id: 'craft_sprinkler', output: 'sprinkler', outputQty: 1, inputs: [{ itemId: 'wood', qty: 5 }] },
  // smelting + minerals
  { id: 'smelt_copper', output: 'copper_bar', outputQty: 1, inputs: [{ itemId: 'copper_ore', qty: 1 }, { itemId: 'coal', qty: 1 }] },
  { id: 'smelt_iron', output: 'iron_bar', outputQty: 1, inputs: [{ itemId: 'iron_ore', qty: 1 }, { itemId: 'coal', qty: 1 }] },
  { id: 'craft_stonepath', output: 'path', outputQty: 4, inputs: [{ itemId: 'stone', qty: 1 }] },
  { id: 'craft_crystal', output: 'crystal', outputQty: 1, inputs: [{ itemId: 'gem', qty: 1 }] },
  { id: 'craft_jewelry', output: 'jewelry', outputQty: 1, inputs: [{ itemId: 'gem', qty: 1 }] },
  { id: 'craft_copper_sprinkler', output: 'copper_sprinkler', outputQty: 1, inputs: [{ itemId: 'sprinkler', qty: 1 }, { itemId: 'copper_bar', qty: 2 }] },
  { id: 'craft_iron_sprinkler', output: 'iron_sprinkler', outputQty: 1, inputs: [{ itemId: 'copper_sprinkler', qty: 1 }, { itemId: 'iron_bar', qty: 2 }] },
];

/** Cooking recipes — made at the stove. Outputs are edible dishes. */
export const COOK_RECIPES: Recipe[] = [
  { id: 'cook_omelette', output: 'omelette', outputQty: 1, inputs: [{ itemId: 'egg', qty: 2 }, { itemId: 'milk', qty: 1 }] },
  { id: 'cook_salad', output: 'garden_salad', outputQty: 1, inputs: [{ itemId: 'tomato', qty: 1 }, { itemId: 'carrot', qty: 1 }, { itemId: 'pepper', qty: 1 }] },
  { id: 'cook_fruit', output: 'fruit_bowl', outputQty: 1, inputs: [{ itemId: 'apple', qty: 1 }, { itemId: 'strawberry', qty: 1 }, { itemId: 'melon', qty: 1 }] },
  { id: 'cook_stew', output: 'veggie_stew', outputQty: 1, inputs: [{ itemId: 'potato', qty: 1 }, { itemId: 'carrot', qty: 1 }, { itemId: 'corn', qty: 1 }, { itemId: 'eggplant', qty: 1 }] },
  { id: 'cook_pie', output: 'pumpkin_pie', outputQty: 1, inputs: [{ itemId: 'pumpkin', qty: 1 }, { itemId: 'milk', qty: 1 }, { itemId: 'egg', qty: 1 }] },
  { id: 'cook_fish', output: 'fish_dinner', outputQty: 1, inputs: [{ itemId: 'fish', qty: 1 }, { itemId: 'potato', qty: 1 }] },
];
